function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useRef, useState, useCallback, useEffect } from 'react';
import { convertToCBSupported } from '@cbhq/intl';
import { useTrackingManager } from '../TrackingManagerContext.js';

/**
 * URL for fetching translations
 */
const TRANSLATIONS_URL = 'https://translations.coinbase.com/aab9bdc6d/latest';
const TRANSLATIONS_FILE_NAME = 'cookie-manager-messages.json';
let cachedTranslations;
const useTranslations = () => {
  const _useTrackingManager = useTrackingManager(),
    onError = _useTrackingManager.onError,
    locale = _useTrackingManager.locale;
  const prevLocale = useRef();
  const _useState = useState(!!cachedTranslations),
    _useState2 = _slicedToArray(_useState, 2),
    loaded = _useState2[0],
    setLoaded = _useState2[1];
  const _useState3 = useState(cachedTranslations || {}),
    _useState4 = _slicedToArray(_useState3, 2),
    translations = _useState4[0],
    setTranslations = _useState4[1];
  const updateTranslations = useCallback(({
    newTranslations = {},
    newLocale
  }) => {
    prevLocale.current = newLocale;
    setTranslations(newTranslations);
    cachedTranslations = newTranslations;
    setLoaded(true);
  }, [setTranslations, setLoaded]);
  const resetTranslations = useCallback(() => {
    setTranslations({});
    cachedTranslations = undefined;
    setLoaded(false);
  }, [setTranslations, setLoaded]);
  useEffect(() => {
    let isMounted = true;
    async function fetchTranslations() {
      // Convert the locale to a CB-supported format (e.g., 'zh' -> 'zh-CN')
      // This ensures we fetch translations for the closest supported locale
      const cbSupportedLocale = convertToCBSupported(locale);
      try {
        const response = await fetch(`${TRANSLATIONS_URL}/${cbSupportedLocale}/${TRANSLATIONS_FILE_NAME}`);
        if (response.ok) {
          const body = await response.json();
          const newTranslations = {};
          Object.keys(body).forEach(key => {
            newTranslations[key] = body[key].defaultMessage;
          });
          if (isMounted) {
            updateTranslations({
              newTranslations,
              newLocale: cbSupportedLocale
            });
          }
        } else {
          throw new Error(`Missing translations for locale: ${cbSupportedLocale}`);
        }
      } catch (e) {
        onError(e);
        if (isMounted) updateTranslations({
          newLocale: cbSupportedLocale
        });
      }
    }
    const isEnglish = ['en', 'en-US'].includes(locale);
    if (!isEnglish && prevLocale.current !== locale) {
      resetTranslations();
      fetchTranslations();
    } else if (isEnglish) {
      updateTranslations({
        newLocale: locale
      });
    }
    return () => {
      isMounted = false;
    };
  }, [onError, locale]);
  return [loaded, translations];
};
export { useTranslations as default };
//# sourceMappingURL=useTranslations.js.map
